import React from 'react';
import { Toaster } from 'react-hot-toast';
import Router from './routes';
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';
// import ReactGA from 'react-ga';
import ReactGA from 'react-ga4';

export default function App() {
  // ReactGA.initialize('UA-251202538-1');
  // ReactGA.pageview(window.location.pathname + window.location.search);

  ReactGA.initialize([
    {
      trackingId: 'G-H9478EDZGV',
      // gaOptions: {...}, // optional
      // gtagOptions: {...}, // optional
    },
  ]);
  return (
    <ThemeConfig>
      <Toaster reverseOrder='true' />
      <GlobalStyles />
      <Router />
    </ThemeConfig>
  );
}
